"use client";
import { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import $ from "jquery";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import { usePageState } from "@/Context/PageState";
import style from "@/styles/Popup.module.scss";
import Link from "next/link";
import ResponsiveSwiper from "@/Components/ResponsiveSwiper";
import { usePathname } from "next/navigation";

const setCookie = (name, value, maxAge) => {
  document.cookie = `${name}=${value}; max-age=${maxAge}; path=/`;
};

const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [key, val] = cookie.split("=");
    if (key === name) return val;
  }
  return null;
};

const Popup = () => {
  const pathname = usePathname();

  const {
    register,
    trigger,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ mode: "all" });

  const [isValidNum, setIsValidNum] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const { CommonSubmitForm, CommonValidateForm, getCountryCode, countryCode, onloadCallback } = usePageState();
  const effectRan = useRef(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const values = getValues();
    // Clean up the phone number before submission
    if (values.mobile && values.mobile.startsWith("0")) {
      values.mobile = values.mobile.substring(1);
    }
    values.mobile = values.mobile.replace(/[\(\)\-]/g, "");
    triggerValidation();

    if (CommonValidateForm(4) == true && isValidNum) {
      CommonSubmitForm(4, values);
      setPhoneNumber(""); // Reset phone number after submission
    } else {
      triggerValidation();
    }
  };

  const triggerValidation = () => {
    trigger(); // all fields
  };

  const onChange = (isValid, rawValue) => {
    const containsOnlyNumbers = /^\d+$/.test(rawValue);
    if (containsOnlyNumbers) {
      setIsValidNum(isValid);
      setPhoneNumber(rawValue);
      setValue("mobile", rawValue);
    } else {
      if (!rawValue) {
        setIsValidNum(isValid);
        setPhoneNumber(rawValue);
        setValue("mobile", rawValue);
      }
    }
  };

  useEffect(() => {
    getCountryCode();
    if (effectRan.current === false) {
      $(document).on("focus blur change", ".contact-form input, .contact-form textarea", function () {
        $(this).val($(this).val().replace(/^\s+/, ""));
      });

      return () => {
        effectRan.current = true;
      };
    }
  }, []);

  const [isShown, setIsShown] = useState(false);
  const showModal = () => {
    setIsShown(true);
    document.body.classList.add("overflowhidden");
  };

  const closeModal = () => {
    setIsShown(false);
    document.body.classList.remove("overflowhidden");
    document.body.classList.remove("overflowhidden");
  };

  useEffect(() => {
    if (!getCookie("vlmspopupModal")) {
      const timer = setTimeout(() => {
        if (!["/contact-us", "/become-a-vidyalaya-partner", "/ebook"].includes(pathname)) {
          showModal();
          setCookie("vlmspopupModal", true, 3600 * 2);
        }
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [pathname]);

  return (
    isShown && (
      // return (
      <>
        <section className={`${style["popup"]}`}>
          <div className={`${style["overlay-div"]}`} onClick={closeModal}></div>
          <div className={`container ${style["serviceform"]}`}>
            <div className={`custom-row ${style["backgroudimg"]}`}>
              <div className={style["leftpart"]}>
                <div className={`${style["paddingbox"]}`}>
                  <div className={`${style["popup-h2div"]}`}>
                    <h2 className={`${style["popuph2"]}`}>Let's Navigate Digital Transformation Together!!!</h2>
                    <div className={`${style["below-line"]}`}></div>

                    <div className={`${style["review-mainmaundiv"]} ${style["review-mainmaundivmb"]}`}>
                      <div className={`${style["review-main"]}`}>
                        <div className={`${style["review-badgessection"]}`}>
                          <img
                            className={`${style["review-imagessection"]} img-fluid`}
                            src="/images/vidyalaya_popup/a1.png"
                            alt="client"
                          />
                          <div></div>
                        </div>
                        <div className={`${style["review-badgessection"]}`}>
                          <img
                            className={`${style["review-imagessection"]} img-fluid`}
                            src="/images/vidyalaya_popup/a2.png"
                            alt="client"
                          />
                          <div></div>
                        </div>
                        <div className={`${style["review-badgessection"]}`}>
                          <img
                            className={`${style["review-imagessection"]} img-fluid`}
                            src="/images/vidyalaya_popup/a3.png"
                            alt="client"
                          />
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${style["fordesktop"]}`}>
                    <div className={`${style["visiblediv"]}`}>
                      <div className={`${style["review-main"]}`}>
                        <div className={`${style["review-badges"]} ${style["review-badges-withlink"]}`}>
                          <Link
                            className={`${style["review-atag"]}`}
                            target="_blank"
                            href={"https://www.softwaresuggest.com/vidyalaya"}
                          >
                            <img
                              className={`${style["review-images"]} img-fluid`}
                              src="/images/vidyalaya_popup/r1.png"
                              alt="client"
                            />

                            <p className={`${style["popup-review-para"]}`}>486 Reviews</p>
                          </Link>
                        </div>
                        <div className={`${style["review-badges"]} ${style["review-badges-withlink"]}`}>
                          <Link
                            className={`${style["review-atag"]}`}
                            target="_blank"
                            href={"https://www.capterra.com/p/142375/Vidyalaya/#reviews"}
                          >
                            <img
                              className={`${style["review-images"]} img-fluid`}
                              src="/images/vidyalaya_popup/r3.png"
                              alt="client"
                            />

                            <p className={`${style["popup-review-para"]}`}>38 Reviews</p>
                          </Link>
                        </div>
                        <div className={`${style["review-badges"]} ${style["review-badges-withlink"]}`}>
                          <Link
                            className={`${style["review-atag"]}`}
                            target="_blank"
                            href={"https://www.goodfirms.co/software/vidyalaya"}
                          >
                            <img
                              className={`${style["review-images"]} img-fluid`}
                              src="/images/vidyalaya_popup/r2.png"
                              alt="client"
                            />

                            <p className={`${style["popup-review-para"]}`}>250 Reviews</p>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className={`${style["visiblediv"]} ${style["onlycentervisiblediv"]}`}>
                      <div className={`${style["review-main"]}`}>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>23+</h4>
                            <h5 className={`${style["count-text"]}`}>Years Legacy</h5>
                          </div>
                        </div>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>1800+</h4>
                            <h5 className={`${style["count-text"]}`}>Clientele</h5>
                          </div>
                        </div>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>1.5 Millions</h4>
                            <h5 className={`${style["count-text"]}`}>Student</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`${style["visiblediv"]}`}>
                      <div className={`${style["review-main"]}`}>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>40+</h4>
                            <h5 className={`${style["count-text"]}`}>Modules</h5>
                          </div>
                        </div>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>96%</h4>
                            <h5 className={`${style["count-text"]}`}>Clients Retention</h5>
                          </div>
                        </div>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>25000+</h4>
                            <h5 className={`${style["count-text"]}`}>Professional Trained</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={style["rightpart"]}>
                <div className={`${style["form-card"]} form-card`}>
                  <div className={`${style["form-card-inner"]} form-card-inner"`}>
                    <h5 className={`${style["cardhead"]} cardhead`}>Contact With Our Experts</h5>

                    <form autoComplete="off" id="contact_form_popup" className="commonform">
                      <div className={`col-sm-12 col-md-12 p-0 mt-1`}>
                        <div className={`${style["input-box"]} input-box`}>
                          <div className="inputmaingroup">
                            <label htmlFor="popupfirst-name" className={`${style["lb"]}`}>
                              Your Name *
                            </label>
                            <input
                              className={`${style["form-control"]} ${style["commondesinclass"]}  required alphabetcheck`}
                              id="popupfirst-name"
                              type="text"
                              name="name"
                              {...register("name", {
                                required: "Name is required",
                                pattern: {
                                  value: /\p{L}/gu,
                                  message: "At least one alphabet character is required",
                                },
                              })}
                            />
                          </div>
                          <div id="name_error" className={`${style["text-danger"]}`}>
                            {errors.name?.message}
                          </div>
                        </div>
                      </div>

                      <div className={`col-sm-12 col-md-12 p-0`}>
                        <div className={`${style["input-box"]} input-box`}>
                          <div className="inputmaingroup">
                            <label htmlFor="popupemail_contact" className={`${style["lb"]}`}>
                              Email Address*
                            </label>
                            <input
                              className={`${style["form-control"]} ${style["commondesinclass"]}`}
                              id="popupemail_contact"
                              type="email"
                              name="email"
                              {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value: /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i,
                                  message: "Email is not valid",
                                },
                              })}
                            />
                          </div>
                          <div id="email_popup_error" className={`${style["text-danger"]}`}>
                            {errors.email?.message}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className={`col-sm-12 col-md-12 p-0 mt-0`}>
                          <div className="row"></div>
                          <div className={`${style["input-box-phone-space"]} col-md-12 col-12`}>
                            <div className={`${style["input-box"]} input-box mb-sm-0`}>
                              <div className="inputmaingroup">
                                <label htmlFor="mobile_contact" className={`${style["lb"]}`}>
                                  Contact Number*
                                </label>

                                {countryCode && (
                                  <IntlTelInput
                                    // type="tel"
                                    numberType={"MOBILE"}
                                    id="mobile_contact"
                                    preferredCountries={["us","gb","in"]}
                                    autoPlaceholder="false"
                                    inputClassName={`contact-us-phone mobile_popup ${style["form-control"]} ${style["commondesinclass"]}`}
                                    // initialCountry="auto"
                                    value={phoneNumber}
                                    defaultCountry={countryCode}
                                    // autoCountryLoaded
                                    // geoIpLookup={true}
                                    onPhoneNumberChange={onChange}
                                    onPhoneNumberBlur={onChange}
                                    // format
                                    // telInputProps={isValidNumber}
                                  />
                                )}
                              </div>
                              <div className={`${style["input-box-phone-space"]} col-12`}>
                                {
                                  <div id="popup-errormsg" className={`${style["text-danger"]}`}>
                                    {!isValidNum && "Please enter valid mobile number"}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <input
                            type="hidden"
                            name="mobile"
                            id="popupcontact"
                            value={phoneNumber}
                            {...register("mobile")}
                          />
                        </div>
                      </div>

                      <div className={`col-sm-12 col-md-12 p-0 mt-1`}>
                        <div className={`${style["input-box"]} input-box`}>
                          <div className="inputmaingroup">
                            <label htmlFor="organisation" className={`${style["lb"]}`}>
                              Institute Name*
                            </label>
                            <input
                              className={`${style["form-control"]} ${style["commondesinclass"]}  required alphabetcheck`}
                              id="organisation"
                              type="text"
                              name="organization"
                              {...register("organization", {
                                required: "Please enter Institute Name",
                                pattern: {
                                  value: /\p{L}/gu,
                                  message: "At least one alphabet character is required",
                                },
                              })}
                            />
                          </div>
                          <div id="name_popup_error" className={`${style["text-danger"]}`}>
                            {errors.organization?.message}
                          </div>
                        </div>
                      </div>
                      <div className={`text-center ${style["example"]}`}>
                        <button
                          type="button"
                          id="IdBtnConnectToExpert"
                          className={`${style["btn"]} btn ${style["send-btn"]} commonformbtn`}
                          onClick={onSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className={`${style["displaydiv"]} ${style["displaymobilediv"]} ${style["counterdiv"]}`}>
                <div className={`${style["review-main"]}`}>
                  <ResponsiveSwiper
                    swiperConfig={{
                      spaceBetween: 20,
                      centerSlide: false,
                      loop: true,
                      slidesPerView: "auto",
                      breakpoints: {
                        320: { slidesPerView: 1 },
                        425: { slidesPerView: 2 },
                        576: { slidesPerView: 3 },
                      },
                      autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                      },
                      navigation: false,

                      className: "commonswiperclass",
                    }}
                  >
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>23+</h4>
                      <h5 className={`${style["count-text"]}`}>Years mobile Legacy</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>1800+</h4>
                      <h5 className={`${style["count-text"]}`}>Clientele</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>1.5 Millions</h4>
                      <h5 className={`${style["count-text"]}`}>Student</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>40+</h4>
                      <h5 className={`${style["count-text"]}`}>Modules</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>96%</h4>
                      <h5 className={`${style["count-text"]}`}>Clients Retention</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>25000+</h4>
                      <h5 className={`${style["count-text"]}`}>Professional Trained</h5>
                    </div>
                  </ResponsiveSwiper>
                </div>
                {/* <div className={`${style["visiblediv"]}`}>
                    <div className={`${style["review-main"]}`}></div>
                  </div> */}
              </div>

              <div className={`${style["client-div"]}`}>
                <ResponsiveSwiper
                  swiperConfig={{
                    spaceBetween: 20,
                    loop: true,
                    slidesPerView: "auto",
                    breakpoints: {
                      320: { slidesPerView: 3 },
                      576: { slidesPerView: 4 },
                    },
                    autoplay: {
                      delay: 3000,
                      disableOnInteraction: false,
                    },
                    navigation: false,

                    className: "commonswiperclass",
                  }}
                >
                  <div className={`${style["clients"]} ${style["clientsfirst"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/1.png" alt="client" />
                  </div>
                  {/* <div className={`${style["clients"]}`}>
                  {" "}
                  <img
                    className={`${style["clientimg"]}`}
                    src="/images/vidyalaya_popup/2.png"
                    alt="client"
                  />
                </div> */}
                  <div className={`${style["clients"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/3.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsvedanata"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/4.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/5.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/11.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsvedanata"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/6.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsholcim"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/7.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/8.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/10.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/9.png" alt="client" />
                  </div>
                </ResponsiveSwiper>
              </div>
            </div>
            <div id="closebtn" className={`${style["closediv"]}`} onClick={closeModal}>
              <span className={`${style["closespan"]}`}>&#10006;</span>
            </div>
          </div>
        </section>
      </>
    )
  );
};

export default Popup;
